import * as React from "react"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"

export interface ModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  title?: string
  description?: string
  children: React.ReactNode
  footer?: React.ReactNode
  onConfirm?: () => void
  onCancel?: () => void
  confirmLabel?: string
  cancelLabel?: string
  confirmVariant?: "default" | "destructive" | "outline" | "secondary" | "ghost" | "link"
  showCancel?: boolean
  isLoading?: boolean
  size?: "sm" | "md" | "lg" | "xl" | "full"
  contentClassName?: string
  hideHeader?: boolean
}

const Modal = ({
  open,
  onOpenChange,
  title,
  description,
  children,
  footer,
  onConfirm,
  onCancel,
  confirmLabel = "Confirmer",
  cancelLabel = "Annuler",
  confirmVariant = "default",
  showCancel = true,
  isLoading = false,
  size = "md",
  contentClassName,
  hideHeader = false,
}: ModalProps) => {
  const sizeClasses = {
    sm: "max-w-sm",
    md: "max-w-lg",
    lg: "max-w-3xl",
    xl: "max-w-4xl",
    full: "max-w-[95vw]",
  }

  const handleCancel = () => {
    if (onCancel) {
      onCancel()
    } else {
      onOpenChange(false)
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className={`${sizeClasses[size]} ${contentClassName || ''} max-h-[90vh] overflow-y-auto custom-scrollbar`}>
        {!hideHeader && (title || description) && (
          <DialogHeader>
            {title && <DialogTitle>{title}</DialogTitle>}
            {description && <DialogDescription>{description}</DialogDescription>}
          </DialogHeader>
        )}
        <div className="py-4">{children}</div>
        {footer || (onConfirm || showCancel) ? (
          <DialogFooter>
            {footer || (
              <>
                {showCancel && (
                  <Button
                    type="button"
                    variant="outline"
                    onClick={handleCancel}
                    disabled={isLoading}
                  >
                    {cancelLabel}
                  </Button>
                )}
                {onConfirm && (
                  <Button
                    type="button"
                    variant={confirmVariant}
                    onClick={onConfirm}
                    isLoading={isLoading}
                  >
                    {confirmLabel}
                  </Button>
                )}
              </>
            )}
          </DialogFooter>
        ) : null}
      </DialogContent>
    </Dialog>
  )
}

export { Modal }

